import React from 'react';
import { Drawer, Tag, Divider, Typography, Input, Button } from 'antd';
import { useSelector } from 'react-redux';
import { useGptResponses } from '../Hooks/useGptResponses';
import ResponseMessage from './ResponseMessage';

export default function PromptDrawer({ visible, onClose, prompts }) {
  const { customPrompt, setCustomPrompt, submitPrompt } = useGptResponses();
  const responses = useSelector(state => state.gptApi.responses);

  return (
    <Drawer
      title="Select a Prompt"
      placement="right"
      closable={true}
      onClose={onClose}
      visible={visible}
      width={800}
    >
      {Object.entries(prompts).map(([key, { title, prompt }]) => (
        <Tag
          key={key}
          color="blue"
          bordered={false}
          onClick={() => submitPrompt(prompt)}
          style={{ margin: 5, cursor: 'pointer' }}
        >
          {title}
        </Tag>
      ))}
      <Divider />
      <Input.TextArea
        value={customPrompt}
        onChange={(e) => setCustomPrompt(e.target.value)}
        placeholder="Ask a question, review a proposal, or dive into some market research"
        autosize={{ minRows: 2, maxRows: 6 }}
      />
      <Button
        type="primary"
        onClick={() => submitPrompt(customPrompt)}
        style={{ marginTop: 10 }}
      >
        SUBMIT
      </Button>
      <Divider />
      <Typography.Title level={5}>Responses</Typography.Title>
      <div>
        {Object.values(responses).map(response => (
          <ResponseMessage key={response.id} response={response} timestamp={response.timestamp} />
        ))}
      </div>
    </Drawer>
  );
}
